import React from 'react';
import Checkbox from '../../Checkbox';
import Radio from '../../Radio';
import { CUSTOM_ROW } from '../common';
export default function RowSelection(_ref, _ref2) {
  var columns = _ref.columns;
  var rowSelection = _ref2.rowSelection;

  if (!rowSelection) {
    return {};
  }

  var type = rowSelection.type,
      _rowSelection$getProp = rowSelection.getProps,
      getProps = _rowSelection$getProp === void 0 ? function () {
    return null;
  } : _rowSelection$getProp,
      allProps = rowSelection.allProps;

  var rowClassName = function rowClassName() {
    var _getProps;

    return (_getProps = getProps.apply(void 0, arguments)) !== null && _getProps !== void 0 && _getProps.checked ? 'jmtd-table-row-checked' : '';
  };

  if (type === 'checkbox') {
    return {
      rowClassName: rowClassName,
      columns: [{
        fitContent: true,
        title: allProps ? /*#__PURE__*/React.createElement(Checkbox, allProps) : '',
        affix: true,
        render: function render(_, row) {
          if (row[CUSTOM_ROW]) {
            return null;
          }

          for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          var props = getProps.apply(void 0, [row].concat(args));
          return props && /*#__PURE__*/React.createElement(Checkbox, props);
        }
      }].concat(columns)
    };
  }

  if (type === 'radio') {
    return {
      rowClassName: rowClassName,
      columns: [{
        fitContent: true,
        affix: true,
        render: function render(_, row) {
          if (row[CUSTOM_ROW]) {
            return null;
          }

          for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
            args[_key2 - 2] = arguments[_key2];
          }

          var props = getProps.apply(void 0, [row].concat(args));
          return props && /*#__PURE__*/React.createElement(Radio, props);
        }
      }].concat(columns)
    };
  }

  return {};
}